module.exports = __webpack_public_path__ + "ba964f95270c491e792d1ea571d7c0eb.jpg";